<template>
  <div>
    <v-data-table
      :loading="isLoading"
      :headers="headers"
      :items="items"
      :items-per-page="5"
      item-key="learnerId"
      :search="search"
      class="elevation-1 mb-10"
      @click:row="onRowClick"
      style="cursor: pointer"
      v-model="selectedLearners"
      :showSelect="items.length > 0 && $store.state.role == 'ao'"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>
            <b>{{ $t(title) }}</b>
          </v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <div class="search-bar">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              :label="$t('table.search')"
              single-line
              hide-details
            ></v-text-field>
          </div>
          <v-spacer></v-spacer>

          <v-btn
            tile
            style="color: #fff"
            class="mb-2 primary-color"
            v-if="items.length > 0 && $store.state.role == 'ao'"
            :disabled="selectedLearners.length <= 0"
            @click="onApproveLearners()"
            >Approve selected</v-btn
          >
        </v-toolbar>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    headers: Array,
    items: Array,
    title: String,
    isLoading: Boolean,
  },
  data: () => ({
    show: false,
    search: "",
    deleteDialog: false,
    selectedLearners: [],
  }),
  methods: {
    onRowClick(item) {
      this.$router.push({
        path: "pending-learners/details",
        query: {
          centreId: item.centreId,
          learnerId: item.learnerId,
          code: item.code,
        },
      });
    },
    onApproveLearners: async function () {
      const learnerIds = this.selectedLearners.map((learner) => {
        return { centreId: learner.centreId, learnerId: learner.learnerId };
      });

      const response = await fetch(
        `${process.env.VUE_APP_ROOT_API}/centres/learners/batch`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.$store.state.jwt}`,
          },
          body: JSON.stringify({ learnerIds }),
        }
      );

      await response.json();
      this.$emit("approveLearners");
    },
  },
};
</script>

<style scoped>
.search-bar {
  width: 200px;
}
</style>